import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { WarehouseGrnContainerModel } from "../../../../../models/aggregates/warehouse/index";

@Injectable({ providedIn: "root" })
export class WarehouseReceivingDocService extends BaseApiTemplateService<WarehouseGrnContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/warehouse-grns/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/warehouse-grns/backoffice-ep";
    this.httpClient = http;
  }
}
